import { ReactNode } from "react"
import { HelpModalContext, BookNavModalContext } from "./Contexts"

const Provider = ({
  children,
  isHelpOpen,
  setIsHelpOpen,
  isBookNavOpen,
  setIsBookNavOpen,
}: {
  children: ReactNode
  isHelpOpen: boolean
  setIsHelpOpen: (state: boolean) => void
  isBookNavOpen: boolean
  setIsBookNavOpen: (state: boolean) => void
}) => {
  return (
    <HelpModalContext.Provider value={{ isOpen: isHelpOpen, setIsOpen: setIsHelpOpen }}>
      <BookNavModalContext.Provider value={{ isOpen: isBookNavOpen, setIsOpen: setIsBookNavOpen }}>
        {children}
      </BookNavModalContext.Provider>
    </HelpModalContext.Provider>
  )
}

export default Provider
